import { gql, useMutation } from '@apollo/client';

// Define the GraphQL mutation for updating a department
const UPDATE_ORG_DEPARTMENT = gql`
  mutation UpdateOrgDepartment(
    $facultyId: ID!
    $departmentId: ID!
    $input: UpdateDepartmentInput!
  ) {
    updateOrgDepartment(
      facultyId: $facultyId
      departmentId: $departmentId
      input: $input
    ) {
      id
      abbreviation
      title
      effectiveFrom
      effectiveTo
      school
      isActive
      head {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      director {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      drcChair {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
      drcSecretaries {
        netId
        email
        surname
        givenName
        title
        department
        effectiveFrom
        effectiveTo
      }
    }
  }
`;

export const useUpdateOrgDepartment = (): any => {
  const [updateOrgDepartment, { loading, error, data }] = useMutation(
    UPDATE_ORG_DEPARTMENT,
  );

  return {
    updateOrgDepartment,
    loading,
    error,
    data,
  };
};
